'use client'

import React, { ReactNode, useEffect, useId } from "react"

type PillsTabsProps = {
    id: string,
    tabs: ReactNode[]
}

export function PillsTabs({
    id,
    tabs
}: PillsTabsProps) {

    useEffect(() => {

        const load = async () => {
            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            var triggerTabList = [].slice.call(document.querySelectorAll('#myTab a'))
            triggerTabList.forEach(function (triggerEl) {
                var tabTrigger = new bootstrap.Tab(triggerEl)

                triggerEl.addEventListener('click', function (event) {
                    event.preventDefault()
                    tabTrigger.show()
                })
            })
        }

        load()
    }, [])

    return (
        <>
            <ul className="nav nav-pills mb-3" role="tablist">
                {tabs.map((tab, indexTab) => {
                    return (
                        <React.Fragment key={"tab-" + indexTab}>
                            <li className="nav-item" role="presentation">
                                <button className={"nav-link" + (indexTab === 0 ? ' active' : '')} id={id + '-' + indexTab + '-tab'} data-bs-toggle="pill" data-bs-target={'#' + id + '-' + indexTab} type="button" role="tab" aria-controls={id + '-' + indexTab} aria-selected={indexTab === 0}>
                                    {tab}
                                </button>
                            </li>
                        </React.Fragment>
                    )
                })}
            </ul>
        </>
    )
}

type PillsContentProps = {
    id: string,
    contents: ReactNode[]
}

export function PillsContent({
    id,
    contents
}: PillsContentProps) {

    return (
        <>
            <div className="tab-content">
                {contents.map((content, indexContent) => {
                    return (
                        <React.Fragment key={"pillcontent-" + indexContent}>
                            <div className={"tab-pane fade show" + (indexContent === 0 ? " active" : "")} id={id + '-' + indexContent} role="tabpanel" aria-labelledby={id + '-' + indexContent + '-tab'} tabIndex={0}>
                                {content}
                            </div>
                        </React.Fragment>
                    )
                })}
            </div>
        </>
    )
}